import React, { useEffect, useState } from "react"
import TextField from "@material-ui/core/TextField"
import { useTranslation } from "react-i18next"
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete"
import { useDispatch, useSelector } from "react-redux"
import { tagButtonClickedReset } from "../../actions/customTagsActions"
import { documentsActions, updateFileTag } from "../../actions/documentsActions"
import { useTheme } from "@material-ui/core/styles"
import { LOCAL_STORAGE_KEYS } from "../../utils"

const filter = createFilterOptions()

function CreateTag(props) {
	const [value, setValue] = useState(null)
	const [tagOptions, setTagOptions] = useState([])
	const dispatch = useDispatch()
	const theme = useTheme()
	const [t] = useTranslation("global")
	const { tags } = useSelector((state) => state.tags.custom_tags)
	const { id, job_id } = useSelector((state) => state?.review?.review)
	const authentication = useSelector((state) => state.authtentication)

	const createNewTag = (tag) => {
		const color = theme?.palette?.tag?.owner?.slice(0, 7)
		const newTag = tag?.inputValue?.trim()
		if (newTag) {
			const currContext = props?.currentContext()
			let fileData = {
				document_id: props?.fileId,
				tag_id: "",
				context: currContext?.name,
				context_id: currContext?.id,
				type: "update",
				user_id: authentication.user.token.userid,
				name: `${authentication.user.user.first_name} ${authentication.user.user.last_name}`,
			}

			dispatch(documentsActions.setPriorityCustomTagAction(newTag, color, null, fileData))
		}

		dispatch(tagButtonClickedReset())
		props?.setShowApplyTag(false)
	}

	const applyTag = (tag) => {
		if (tag?.id) {
			const currContext = props?.currentContext()
			dispatch(
				updateFileTag({
					document_id: props?.fileId,
					tag_id: tag?.id,
					context: currContext?.name,
					context_id: currContext?.id,
					type: "update",
					user_id: authentication.user.token.userid,
					name: `${authentication.user.user.first_name} ${authentication.user.user.last_name}`,
				})
			)
			//register tag is added
			localStorage.setItem(LOCAL_STORAGE_KEYS.TRIGGER_P_SEARCH, true)
		}
		dispatch(tagButtonClickedReset())
		props?.setShowApplyTag(false)
	}

	const getNotAppliedTagData = (tagMaster, selectedTags) => {
		let remainingOptions = []
		tagMaster?.map((item, index) => {
			let found = selectedTags?.filter((selectedTag) => selectedTag?.tag_id === item?.id)
			if (!found?.length) {
				remainingOptions?.push(tagMaster[index])
			}
		})

		return remainingOptions
	}

	useEffect(() => {
		let remainingOptions = []
		if (tags?.length && props?.tagData?.length) {
			remainingOptions = getNotAppliedTagData(tags, props?.tagData)
		} else {
			tags?.length && setTagOptions(tags)
		}
		remainingOptions?.length && setTagOptions(remainingOptions)
	}, [tags, props?.tagData])

	return (
		<Autocomplete
			value={value}
			onChange={(event, newValue) => {
				if (typeof newValue === "string") {
					setValue({
						name: newValue,
					})
					createNewTag(newValue)
				} else if (newValue && newValue?.inputValue) {
					setValue({
						name: newValue?.inputValue,
					})
					createNewTag(newValue)
				} else {
					setValue(newValue)
					applyTag(newValue)
				}
			}}
			onBlur={(e, newVal) => {
				dispatch(tagButtonClickedReset())
				props?.setShowApplyTag(false)
			}}
			filterOptions={(options, params) => {
				const filtered = filter(options, params)
				if (params?.inputValue !== "") {
					filtered.push({
						inputValue: params?.inputValue,
						name: `${t("tag.newTag")} "${params?.inputValue}"`,
					})
				}
				return filtered
			}}
			selectOnFocus
			clearOnBlur
			handleHomeEndKeys
			id={`tag-apply-create-${props?.fileId}`}
			options={tagOptions}
			getOptionLabel={(option) => {
				if (typeof option === "string") {
					return option
				}
				if (option?.inputValue) {
					return option?.inputValue
				}
				return option?.name
			}}
			renderOption={(option) => option?.name}
			style={{ width: 300 }}
			freeSolo
			renderInput={(params) => (
				<TextField
					{...params}
					inputProps={{ ...params?.inputProps, maxLength: 50 }}
					variant="outlined"
					placeholder={t("tag.createOrApply")}
				/>
			)}
		/>
	)
}

export default CreateTag
